import { render } from "./DiscountRequestDetails.vue?vue&type=template&id=0cce7b17"
import script from "./DiscountRequestDetails.vue?vue&type=script&lang=js"
export * from "./DiscountRequestDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__